"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BrandItemImgBack_1 = require("./BrandItemImgBack");
var BrandItemImg_1 = require("./BrandItemImg");
var BrandAreaImg = /** @class */ (function (_super) {
    __extends(BrandAreaImg, _super);
    function BrandAreaImg(props) {
        return _super.call(this, props) || this;
    }
    BrandAreaImg.prototype.componentWillMount = function () {
        var _this = this;
        var dList = this.props.data.getBrandItemById(this.props.brandId).directories;
        var canBreak = false;
        this.setState({ dirList: dList });
        for (var i = 0; i < dList.length; i++) {
            if (canBreak) {
                break;
            }
            if (dList[i].dirName === this.props.dirName) {
                this.setState({
                    dir: dList[i]
                }, function () {
                    canBreak = true;
                });
            }
        }
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            dList = _this.props.data.getBrandItemById(_this.props.brandId).directories;
            canBreak = false;
            _this.setState({ dirList: dList });
            for (var i = 0; i < dList.length; i++) {
                if (canBreak) {
                    break;
                }
                if (dList[i].dirName === _this.props.dirName) {
                    _this.setState({
                        dir: dList[i]
                    }, function () {
                        canBreak = true;
                    });
                }
            }
        });
    };
    BrandAreaImg.prototype.componentWillReceiveProps = function (nextProps) {
        var dirList = nextProps.data.getBrandItemById(nextProps.brandId).directories;
        var canBreak = false;
        for (var i = 0; i < dirList.length; i++) {
            if (canBreak) {
                break;
            }
            if (dirList[i].dirName === nextProps.dirName) {
                this.setState({
                    dir: dirList[i]
                }, function () {
                    canBreak = true;
                });
            }
        }
    };
    BrandAreaImg.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandAreaImg.prototype.selectImageClick = function (brandId, dirName, fileName) {
        if (this.props.onSelectImage) {
            this.props.onSelectImage(brandId, dirName, fileName);
        }
    };
    BrandAreaImg.prototype.getRenderObjectList = function () {
        var _this = this;
        var _ret = [];
        _ret.push(React.createElement(BrandItemImgBack_1.default, { title: "\u041D\u0430\u0437\u0430\u0434", brandId: this.props.brandId, key: "back-" + this.props.brandId + "-dir}", onBackClick: function (brandId) {
                if (_this.props.onGoBackClick) {
                    _this.props.onGoBackClick(brandId);
                }
            } }));
        for (var i = 0; i < this.state.dir.files.length; i++) {
            _ret.push(React.createElement(BrandItemImg_1.default, { dirName: this.state.dir.dirName, fileName: this.state.dir.files[i].fileName, cdnUrl: this.props.data.DATA.cdn_baseurl, brand: this.props.data.getBrandItemById(this.props.brandId), key: "img-" + this.props.brandId + "-" + this.state.dir.files[i].fileName, onSelectClick: this.selectImageClick.bind(this) }));
        }
        return _ret;
    };
    BrandAreaImg.prototype.render = function () {
        return (React.createElement("div", { style: {
                width: "100%",
                borderColor: "black",
                borderStyle: "solid",
                borderLeftWidth: "0px",
                borderTopWidth: "1px",
                borderRightWidth: "1px",
                borderBottomWidth: "1px",
                display: "flex",
                justifyContent: "flex-start",
                alignContent: "flex-start",
                alignItems: "flex-start",
                justifyItems: "flex-start",
                flexDirection: "row",
                flexWrap: "wrap",
                overflowY: "scroll",
                overflowX: "hidden"
            } }, this.getRenderObjectList()));
    };
    return BrandAreaImg;
}(React.Component));
exports.default = BrandAreaImg;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/dlgSelectBrandImage/controls/BrandAreaImg.tsx
// module id = 2394
// module chunks = 0